export const ZENDESK_EDITOR_BASE_URL =
  'https://clinchflightcontrol.zendesk.com/knowledge/articles/';
export const ZENDESK_EDITOR_PARAMS = '/en-us';
export const CLONED_DRAFT_PREFIX = 'DRAFTOF:';
